import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import * as React from "react";
import { createRoot } from "react-dom/client";
import * as serviceWorker from "./serviceWorker";
import { CircularProgress } from "@mui/material";
import { Settings } from "@havi/common";
import baseName from "./BaseName";

const rootEl = document.getElementById("root")!;
const root = createRoot(rootEl);

const loader = (
  <div
    style={{
      position: "absolute",
      width: "99vw",
      height: "99vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden"
    }}
  >
    <CircularProgress style={{ color: "#006cb6" }} size={70} thickness={2} />
  </div>
);

function startRoot() {
  const ReduxRoot = React.lazy(() => import("./ReduxRoot"));

  root.render(
    <React.Suspense fallback={loader}>
      <ReduxRoot />
    </React.Suspense>
  );
}

async function index() {
  await Settings.configure({ basename: baseName });

  // const metadata = (await axios(Storage.Settings.metadata_uri)).data;
  // const signInKeys = (await axios(metadata.jwks_uri)).data;
  // Storage.LoginMetadata = metadata;
  // Storage.LoginSigninKeys = signInKeys;
  startRoot();
}

// Initial loader render
root.render(loader);

index();

serviceWorker.unregister();
